import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App from "@/App";

// Remove Emergent branding elements
const removeEmergentBranding = () => {
  const selectors = [
    '[data-emergent]',
    '[class*="emergent"]',
    '[id*="emergent"]',
    '.emergent-badge',
    '.emergent-branding',
    '.made-with-emergent',
    'a[href*="emergent"]',
    'div[class*="Emergent"]',
    'div[id*="Emergent"]',
    'iframe[src*="emergent"]'
  ];
  
  selectors.forEach(selector => {
    try {
      document.querySelectorAll(selector).forEach(el => {
        el.style.display = 'none';
        el.remove();
      });
    } catch (e) {}
  });
};

// Run on load and observe for dynamic injections
if (typeof window !== 'undefined') {
  // Initial cleanup
  removeEmergentBranding();
  window.addEventListener('load', removeEmergentBranding);
  
  // Observer for dynamically injected elements
  const observer = new MutationObserver((mutations) => {
    mutations.forEach(() => removeEmergentBranding());
  });
  
  if (document.body) {
    observer.observe(document.body, { childList: true, subtree: true });
  } else {
    document.addEventListener('DOMContentLoaded', () => {
      observer.observe(document.body, { childList: true, subtree: true });
    });
  }
}

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
